import React, { useEffect, useState,useRef } from 'react'
import { Box, Stack, Table, TableHead, InputAdornment, TableContainer,  Menu, MenuItem, Skeleton, TableBody, IconButton, TableCell, TableRow, PaginationItem, Pagination, TextField } from "@mui/material";
import { StyledTableRow, StyledTableCell } from "../../Theme"
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import { FaMinus } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { ReactComponent as DepositIcon } from '../../img/transactionDeposit.svg';
import { ReactComponent as WithdrawIcon } from '../../img/TransactionWithdraw.svg';
import { ReactComponent as PaginationForwardIcon } from '../../img/PaginationForwardIcon.svg';
import { ReactComponent as PaginationBackArrowIcon } from '../../img/PaginationBackArrow.svg';
import { ApiService } from '../../API/AxiosInstance';
import { getSymbol } from '../Overview';
import moment from 'moment';
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import FeatureSoon from '../../components/FeatureSoon';
import { captureException } from '@sentry/react';
import BackArrow from '../../img/products/BackArrow.png';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as NotifyIcon } from '../../img/notifyIcon2.svg';
import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as DotsIcon } from '../../img/DotsIcon.svg'
import { ReactComponent as SearchIcon } from '../../img/search.svg'
import { ReactComponent as Updates } from "../../img/notifications/Updates.svg"
import { ReactComponent as AccountActivity } from "../../img/notifications/Account Activity.svg"
import { ReactComponent as Alert } from "../../img/notifications/Alert.svg"
import { ReactComponent as Announcement } from "../../img/notifications/Announcement.svg"
import { ReactComponent as General } from "../../img/notifications/General.svg"
import ToastAlert from '../../utils/Toaster';
import { useQuery } from "@tanstack/react-query";
import CustomPagination from '../../components/CustomPagination';
import { useNotifications } from '../../redux/apiCalls';
import { isRead } from '../../utils/validation';
import NotificationItem from './NotificationItem';
import { colors } from '../../Theme/tokens';
import ConfirmDeleteDialog from '../../components/ConfirmDeleteDialog ';

const notificationIcons = {
  1: General,
  2: Announcement,
  3: Alert,
  4: AccountActivity,
  5: Updates
};

export const containerStyle = {
    width: "100%",
    maxWidth: "1580px",
};

export const titleStyle = {
    fontSize: "14px",
    color: colors.neutral.outlinedText,
    fontWeight: 500,
};

export const bodyStyle = {
    fontSize: "12px",
    color: "rgba(17, 17, 17, 0.6)",
    fontWeight: 400,
};

export const cardStyle = {
    backgroundColor: "White_color",
    borderRadius: "18px",
    padding: { sm: "20px", xs: "20px 10px" },
};

export const headingStyle = {
    fontSize: { xs: "21px", sm: "23.99px" },
    lineHeight: "29.03px",
    color: colors.neutral.outlinedText,
    fontWeight: 600,
};

export const backTextStyle = {
    fontSize: "14px",
    color: colors.text.secondary,
    fontWeight: 500,
    lineHeight: "18.73px",
    letterSpacing: "5%",
    };


const NotificationList = () => {
    const navigate = useNavigate()
    // const [notificationList,setNotificationList] = useState([])
    // const [loading,setLoading] = useState(false)
    const [anchorEle,setAnchorEle] = useState(null)
    const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
    const [selectedId,setSelectedId] = useState(null)
    const [apiLoader,setApiLoader] = useState(false)
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [searchText,setSearchText] = useState("")
    const [debouncedSearchValue, setDebouncedSearchValue] = useState("")
    const [allNotificationList,setAllNotificationList] = useState([])
    const {  user } = useAuth0();
    //Pagination state
    const [page, setPage] = useState(0);  
    const [limit, setLimit] = useState(10);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedNotificationId,setSelectedNotificationId] = useState(null)

  const { notifications, hasMore, isLoading, isError, refetch } = useNotifications({
    subId: user?.sub_id,
    page,
    limit,
  });


    const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(0); 
    };

    const start = page * limit + 1;
    const end = page * limit + notifications.length;

    useEffect(() => {
        const delayedInputTimeoutId = setTimeout(() => {
            setDebouncedSearchValue(searchText)
        },500)
        return () => clearTimeout(delayedInputTimeoutId)
    },[searchText])

    const IconContainer = (mainCategoryId) => {
        
        const Icon = notificationIcons[mainCategoryId.mainCategoryId];
        return(
            <Box sx={{width:"36px", height:"36px", backgroundColor: colors.background.iconBox, borderRadius:"7.58px", display:"flex", justifyContent:"center", alignItems:"center" }}>
                {Icon ? <Icon /> : <General />}
            </Box>
        )
    }

    const handleClick = (event,notificationId,notification) => {
        event.stopPropagation()
        setAnchorEle(event.currentTarget);
        setSelectedId(notificationId)
        setSelectedNotification(notification)
    };

    const handleClose = () => {
        setAnchorEle(null);
        if(deleteModal) {
            setDeleteModal(false)
        }
    };

    const selectedUser_id = selectedNotification?.userNotificationStatuses[0]?.userId

    const handleArchive = async() => {
        const apiUrl = checkIsArchived(selectedNotification) ? `notifications/${selectedId}/users/${selectedUser_id}/unarchive/update` : `notifications/${selectedId}/users/${selectedUser_id}/archive/update`
        setApiLoader(true)
        try {
            const response = await ApiService().post(apiUrl)
            if(response?.status === 200) {
                setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
                // refetch()
                console.log("should be called")
                setTimeout(()=>{
                    setToastStatus({color:'',status:false, message:""})
                    setApiLoader(false)
                    refetch()
                },3000)
            }
        } catch(error) {
            console.log("error ",error)
            setToastStatus({color:'red',status:true,message: error?.response?.data?.message || "Somthing went wrong",icon:'close'})
            setTimeout(()=>{
                setToastStatus({color:'',status:false, message:""})
                setApiLoader(false)
            },3000)
        } finally {
            handleClose()
            
        }
    }

    const handleConfirmDelete = async() => {
        console.log("final ",`notifications/${selectedId}/users/${selectedUser_id}/delete`)
        setApiLoader(true)
           try {
            const response = await ApiService().post(`notifications/${selectedId}/users/${selectedUser_id}/delete`)
            if(response?.status === 200) {
                setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
                refetch()
                setTimeout(()=>{
                    setToastStatus({color:'',status:false, message:""})
                    setApiLoader(false)
                },3000)
            }
        } catch(error) {
            setToastStatus({color:'red',status:true,message: error?.response?.data?.message || "Somthing went wrong",icon:'close'})
            setTimeout(()=>{
                setToastStatus({color:'',status:false, message:""})
                setApiLoader(false)
            },3000)
        } finally {
            setSelectedId(null)
            setSelectedNotification(null)
            handleClose()

        }
    }

        const handleResend = async(notification) => {
            console.log("notification ",notification)
        setApiLoader(true)

        const payload = {to: notification?.userNotificationStatuses[0]?.userId, notification: {
            title: notification?.title,
            body:  notification?.body,
            platforms:  notification?.platforms,
            mainCategoryId:  notification?.mainCategoryId,
            subCategoryId: notification?.subCategoryId
        }}
           try {
            const response = await ApiService().post(`notifications/${selectedId || notification?.notificationId}/users/${selectedUser_id || notification?.userNotificationStatuses[0]?.userId}/resend`)
            if(response?.status === 200) {
                setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
                refetch()
                setTimeout(()=>{
                    setToastStatus({color:'',status:false, message:""})
                    setApiLoader(false)
                },3000)
            }
        } catch(error) {
            setToastStatus({color:'red',status:true,message: error?.response?.data?.message || "Somthing went wrong",icon:'close'})
            setTimeout(()=>{
                setToastStatus({color:'',status:false, message:""})
                setApiLoader(false)
            },3000)
        } finally {
            handleClose()
        }
    }


    

    const handleChangeStatus = async(notificationId) => {
        if(apiLoader) return
        setApiLoader(true)
        try {
            const response = await ApiService().post(`notifications/${notificationId}/users/${selectedUser_id}/status/read`)
             if(response?.status === 200) {
                setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
                setTimeout(()=>{
                    setToastStatus({color:'',status:false, message:""})
                    setApiLoader(false)
                    refetch()
                },3000)
            }
        } catch(error) {
            console.log("error ",error)
            setToastStatus({color:'red',status:true,message: error?.response?.data?.message || "Somthing went wrong",icon:'close'})
            setTimeout(()=>{
                setToastStatus({color:'',status:false, message:""})
                setApiLoader(false)
            },3000)
        } finally {

        }
    }
    
    const handleDeleteClick = () => {
        setDeleteModal(true);
    };

    const handleDeleteClose = () => {
        setDeleteModal(false);
        handleClose()
    };

    const checkIsArchived = (notification) => {
        return notification?.userNotificationStatuses[0]?.isActive ? false : true
    }

    const newNotifications = notifications?.filter((n) => !isRead(n));

    const pastNotifications = notifications?.filter((n) => isRead(n));

    const subTitleSx = {color: colors.text.primary,  letterSpacing: '2px',fontSize:"14px", fontWeight:"500"};


    const handleRowClick = (notification) => {

    navigate(`/notificationDetail/${notification.notificationId}`, {
        state: { notification: notification, userId: notification?.userNotificationStatuses[0]?.userId }
        });       
    };

    const rowStyle = (notification) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: 2,
    padding: "12px",
    borderRadius: "12px",
    // backgroundColor: isRead(notification) ? "transparent" : colors.background.subtle,
    backgroundColor: "transparent",
    cursor:  "pointer",
    });

    const menuStyle = {
    backgroundColor: "white",
    boxShadow: "0px 5px 3.95px 0px #00000012",
    borderRadius: "10px",
    };

    const emptyStateStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "rgba(17, 17, 17, 0.6)",
    minHeight: "300px",
    };

    return(
        <>
        <ConfirmDeleteDialog
            open={deleteModal}
            onClose={handleDeleteClose}
            onConfirm={handleConfirmDelete}
            title="Delete Notification?"
            message="Are you sure you want to delete this Notification?"
        />
        <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
            {/* <Box backgroundColor='#F0F7FD' height='auto' sx={{width:"100%", maxWidth:"1580px",}}>
                <Box component='div' sx={{backgroundColor: 'White_color',borderRadius: '18px',padding: { sm: '20px', xs: '20px 10px 20px 10px' },}} mt={.5} >
                    <Box sx={{display:"flex", flexDirection:"column", gap:2, mb:2}}>
                        <IconButton onClick={() => navigate(-1)} sx={{display:'flex', width:'fit-content', alignItems:'center', gap:'11.18px', padding:'10px', pl:'0',  borderRadius:'22px'}}>
                            <Box component='img' src={BackArrow}/>
                            <Typography sx={{fontSize:'14px', color:'#8A8C8F', fontWeight:'500', lineHeight:'18.73px', letterSpacing:'5%'}}>Back</Typography>
                        </IconButton>
                        <Typography sx={{ fontSize:{xs:"21px", sm:"23.99px"}, lineHeight:"29.03px", color:"#0D0C2C", fontWeight:"600", letterSpacing:"0%" }}>Notifications</Typography>
                    </Box>
                    {!isLoading ? 
                    notifications?.length >0 ? <Box sx={{display:"flex", flexDirection:"column", gap:2}}>
                        {notifications?.map((notification, index) => (
                            <Box key={index} onClick={() =>  notification?.userNotificationStatuses[0]?.hasRead ? null : handleChangeStatus(notification?.notificationId) } sx={{display:"flex", justifyContent:"space-between", gap:2, padding:"12px", backgroundColor: notification?.userNotificationStatuses[0]?.hasRead ? "transparent" : "#F1F5F9" , borderRadius:"12px", cursor: notification?.userNotificationStatuses[0]?.hasRead ? "normal" : "pointer"}}>
                                <Box sx={{display:"flex", justifyContent:"center", gap: 2}}>
                                    <IconContainer mainCategoryId={notification?.mainCategoryId} />
                                    <Box sx={{display:"flex", flexDirection:"column", gap:1, flex:1}}>
                                        <Typography sx={{ fontSize:"14px", color:"#111111", fontWeight:"500", letterSpacing:"0%" }}>{notification?.title}</Typography>
                                        <Typography sx={{ fontSize:"12px", color:"#11111199", fontWeight:"400", letterSpacing:"0%" }}>{notification?.body}</Typography>
                                    </Box>
                                </Box>
                                <IconButton disabled={apiLoader} onClick={(event) => handleClick(event, notification?.notificationId,notification)}><DotsIcon /></IconButton>
                                        <Menu
                                            anchorEl={anchorEle}
                                            open={Boolean(anchorEle)}
                                            onClose={handleClose}
                                            onClick={(e) => e.stopPropagation()}
                                            slotProps={{
                                                paper: {
                                                sx: {
                                                    backgroundColor: "white",  
                                                    boxShadow: "0px 5px 3.95px 0px #00000012",   
                                                    borderRadius:"10px"
                                                },
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={handleArchive}>{ checkIsArchived() ? 'Unarchive' : 'Archive'}</MenuItem>
                                            <MenuItem onClick={() =>handleDelete(notification?.notificationId)}>Delete</MenuItem>
                                        </Menu>
                        </Box>
                        ))}
                    </Box> : <Box sx={{display:"flex", justifyContent:"center",alignItems:"center", color: "rgba(17, 17, 17, 0.6)", minHeight:"300px"}}>No Notifications found</Box> : (
                        <Table>
                                <TableBody>
                                    {Array.from(new Array(5)).map((_, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        <TableCell>
                                            <ShimmerSkeleton variant="rectangular" width="100%" height={52} sx={{height:"52px !important"}} />
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                    )}
                </Box>
                <CustomPagination
                    page={page}
                    limit={limit}
                    hasMore={hasMore}  // ✅ backend-driven
                    onPageChange={setPage}
                    onLimitChange={handleLimitChange}
                    start={start}
                    end={end}
                    limitOptions={[5, 10, 25]}
                    />
            </Box> */}
            <Box backgroundColor={colors.background.cardBg} height="auto" sx={{...containerStyle,boxShadow: `0px 1px 5px 0px ${colors.border.card}`, borderRadius: '15px'}}>
                <Box component="div" sx={cardStyle} mt={0.5}>
                    
                    {/* 🔹 Header */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
                    
                    <IconButton
                        onClick={() => navigate(-1)}
                        sx={{
                        display: "flex",
                        width: "fit-content",
                        alignItems: "center",
                        gap: "11.18px",
                        padding: "10px",
                        pl: 0,
                        borderRadius: "22px",
                        }}
                    >
                        <Box component="img" src={BackArrow} />
                        <Typography sx={backTextStyle}>Back</Typography>
                    </IconButton>

                    <Typography sx={headingStyle}>Notifications</Typography>
                    </Box>

                    {/* 🔹 Content */}
                    {!isLoading ? (
                    notifications?.length > 0 ? (
                        
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <>
                            {notifications?.map((notification, index) => (
                                <NotificationItem
                                key={notification?.notificationId || index}
                                notification={notification}
                                index={index}
                                apiLoader={apiLoader}
                                rowStyle={rowStyle}
                                titleStyle={titleStyle}
                                bodyStyle={bodyStyle}
                                menuStyle={menuStyle}
                                onRowClick={handleRowClick}
                                onArchive={handleArchive}
                                onDelete={handleDeleteClick}
                                checkIsArchived={checkIsArchived}
                                notificationIcons={notificationIcons}
                                general={<General/>}
                                setSelectedNotification={setSelectedNotification}
                                setSelectedId={setSelectedId}
                                handleResend={handleResend}
                                deleteModal={deleteModal}
                                />
                            ))}
                            </>
                           {/* {pastNotifications?.length > 0 && <>
                        {pastNotifications?.length > 0 && <Typography variant="subtitle2" sx={subTitleSx} >Earlier</Typography>}
                            {pastNotifications?.map((notification, index) => (
                                <NotificationItem
                                key={notification?.notificationId || index}
                                notification={notification}
                                index={index}
                                apiLoader={apiLoader}
                                rowStyle={rowStyle}
                                titleStyle={titleStyle}
                                bodyStyle={bodyStyle}
                                menuStyle={menuStyle}
                                onRowClick={handleRowClick}
                                onArchive={handleArchive}
                                onDelete={handleDelete}
                                checkIsArchived={checkIsArchived}
                                notificationIcons={notificationIcons}
                                general={<General/>}
                                setSelectedNotification={setSelectedNotification}
                                setSelectedId={setSelectedId}
                                handleResend={handleResend}
                                />
                            ))}
                            </>} */}
                        </Box>

                    ) : (
                        <Box sx={emptyStateStyle}>No Notifications found</Box>
                    )
                    ) : (
                    <Table>
                        <TableBody>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <TableRow key={i}>
                            <TableCell>
                                <ShimmerSkeleton
                                variant="rectangular"
                                width="100%"
                                height={52}
                                sx={{ height: "52px !important" }}
                                />
                            </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                    )}
                </Box>

                {/* 🔹 Pagination */}
                <CustomPagination
                    page={page}
                    limit={limit}
                    hasMore={hasMore}
                    onPageChange={setPage}
                    onLimitChange={handleLimitChange}
                    start={start}
                    end={end}
                    limitOptions={[5, 10, 25]}
                />
            </Box>
        </>
    )
}

export default NotificationList;